import * as d3 from "d3";
import cfg from '../config.json';
export function list(sel, data) {
  let trendEqual = data.config.iconTrendEqual;
  let trendUp = data.config.iconTrendUp;
  let trendDown = data.config.iconTrendDown;
  init();

  function init() {

    const regionsData = Array.from(d3
        .group(data.ecoles, d => d.area_name))
        .sort(d3.ascending)
        .map(d => {
          return {
            region_name: d[0]
          }
        });

    const filterRegionOrType = () => {
      var radioValue = d3.select('.radio-input:checked').node().value;
      var selectValue = d3.select('#regions select').property('value');
      let filteredEcoles;

      if (radioValue === 'default' && selectValue === 'default') {
        render_results(data.ecoles)
      } else {
        if (selectValue === 'default') {
          // CASE : toutes les regions, type différent : filtre uniquement sur le type
          if(radioValue === "ehdaa"){
            filteredEcoles = data.ecoles
                .filter(function (d) {
                  if (parseInt(d.ehdaa_2022) >= 30) return d
                })
          } else {
            filteredEcoles = data.ecoles
                .filter(function (d) {
                  if (d.secteur === radioValue) return d
                })
          }

        } else if (radioValue === 'default')  {
          // CASE : tous les types, region différente : filtre uniquement sur la région
          filteredEcoles = data.ecoles
              .filter(function (d) {
                if (d.area_name === selectValue) return d
              })
        }
        else {
          // CASE : région et type différents : filtre sur les deux
          if(radioValue === "ehdaa"){
            filteredEcoles = data.ecoles
                .filter(function (d) {
                  if (parseInt(d.ehdaa_2022) >= 30 && d.area_name === selectValue) return d
                })
          } else {
            filteredEcoles = data.ecoles
                .filter(function (d) {
                  if (d.secteur === radioValue && d.area_name === selectValue) return d
                })
          }
        }
        if (filteredEcoles.length > 0) {
          render_results(filteredEcoles)
        } else {
          render_no_results()
        }
      }
    }

    const filterKeyword = () => {
      var input, filter, table, i;
      input = document.getElementById("keywordInput");
      filter = input.value.toUpperCase();
      table = document.getElementById("rows");
      var rows = table.getElementsByTagName("tr");
      for (i = 0; i < rows.length; i++) {
        rows[i].classList.remove('expanded');
        if (rows[i].classList.contains('details')) {
          rows[i].remove();
        }
        var cells = rows[i].getElementsByTagName("td");
        var j;
        var rowContainsFilter = false;
        for (j = 0; j < cells.length; j++) {
          if (cells[j]) {
            if (cells[j].innerHTML.toUpperCase().indexOf(filter) > -1) {
              rowContainsFilter = true;
              continue;
            }
          }
        }

        if (!rowContainsFilter) {
          rows[i].style.display = "none";
        } else {
          rows[i].style.display = "";
        }
      }
      let visibleRows = document.querySelectorAll('#rows tr:not([style*="display: none"])').length;
      d3.select(".no-result").classed('hidden', visibleRows !== 0);

    }


    const radios = d3.selectAll('.radio-input');
    radios.on('change', filterRegionOrType );

    const keyword = d3
        .select("#keywordInput")
        .on('keyup', filterKeyword)

    const dropdown = d3
        .select("#regions .content .select-wrapper")
        .append('select')
        .attr('class', 'select')
        .attr("name", "region-list")
        .on('change', filterRegionOrType)

    const options = dropdown
        .selectAll('option')
        .data(regionsData)
        .enter()
        .append('option')
        .attr('value',(d) => d.region_name )
        .text( (d) => d.region_name );

    const defaultOption = dropdown
        .append('option')
        .attr('value', 'default')
        .attr('selected', 'selected')
        .text("Toutes les régions")

    function render_no_results() {
      sel
          .select("#results .content")
          .html(`<p class="no-results no-user-select">Aucun résultat</p>`)
    }

    function render_results(ecoles) {
      d3
          .select("#results .content")
          .html(`<div class="table-wrap">
      <table cellpadding="0" cellspacing="0" class="sortable">
        <thead class="table-head">
            <tr>
                <th class="disable-sort">Comparer</th>
                <th class="pointer ecole dir-u ">École</th>
                <th class="pointer municipalite ">Municipalité</th>
                <th class="pointer cote2019 hide-on-mobile"><span>Cote 2019</span></th>
                <th class="pointer cote2022 ">Cote <span class="hide-on-mobile">2022</span></th>
                <th class="details disable-sort">Détails</th>
            </tr>
        </thead>
        <tbody id="rows" class="table-body">
            
        </tbody>
      </table>
      </div>
     
    `);


      var row = d3
          .select("#results")
          .select("#rows")
          .selectAll(".row")
          .data(ecoles, (d, i) => `row-${i}`)
          .enter()
          .call(render_row)

      filterKeyword();

      d3.selectAll(".details-toggle")
          .on("click", toggle_details)
    }

    const render_row = (sel) => {

      const row = sel.append('tr')
          .attr("class","row summary first")
          .classed('added-to-comparator',(d)=>d.compared)
          .attr("id", function(d,i){ return "summary"+i});

      const checkbox = row.append('td').attr('class','checkbox');
      const pnum = function(str) {
        if (str == "nd") return str;
        return str.replace(/\./, ",");
      }

          row.append('td').html((d) => d.nom);
          row.append('td').html((d) => d.municipalite);
          row.append('td').attr('class','hide-on-mobile').attr('data-sort',(d) => d.cote_2019 === "nd" ? "0.0" : d.cote_2019).html((d) => `<span>${pnum(d.cote_2019)}</span>`);
          row.append('td').attr('data-sort',(d) => d.cote_2022 === "nd" ? "0.0" : d.cote_2022).html((d) => pnum(d.cote_2022));
          row.append('td').attr('class','details-toggle').html(`<span class="material-symbols-rounded">add</span>`);


      checkbox
          .append("input")
          .attr("type", "checkbox")
          .attr("class", "cb-school")
          .property("checked",(d)=>d.compared)
          .attr("id", d => `checkbox-${d.school_code}`)
          .on("change", function (e) {
            const d = d3.select(this).datum();
            var row = e.target.closest('tr');
            if (e.target.checked) {
              document.dispatchEvent(new CustomEvent("list-row-selected", {detail: d}));
              row.classList.add('added-to-comparator');
              d.compared = true;
            } else {
              document.dispatchEvent(new CustomEvent("list-row-deselected", {detail: d}));
              row.classList.remove('added-to-comparator')
              d.compared = false;
            }
            update_checkboxes();
          });

    }

    const toggle_details = (e) => {

      let sel = d3.select(e.target.parentNode)
      let d = sel.datum()
      let selId = "#"+e.target.parentNode.id+" + *";
      let selDetailsId = "#"+e.target.parentNode.id+" + .details.expanded";
      let newflag = !sel.classed("expanded")
      /** if not already expanded, append infos **/
      if (newflag) {
        sel.classed("expanded",newflag)
        d3.select('#rows')
            .insert('tr', selId)
            .attr('class', 'row details second expanded')
            .html(t => {
              const returnProperIcon = (trend) => {
                let icon = trend === '112233' ? trendUp : trendEqual;
                icon = trend === "998855" ? trendDown : icon;
                return trend === "nd" ? "nd" : icon;
              }
              const pnum = function(str) {
                if (str == "nd") return str;
                return str.replace(/\./, ",");
              }

              const francoAnglo = d.langue === "français" ? "francophone" : "anglophone";
              const financement = d.secteur === "public" ? "publique" : "privée";
              const ehdaaTxt = d.ehdaa_2022 === "nd" ? `(proportion EHDAA inconnue)` : `(dont <span class="tx-darkblue tx-bold">${pnum(d.ehdaa_2022)}&nbsp;%</span> EHDAA)`;


              return `<td class="content no-user-select" colspan="7">
               <div class="detailed-infos">
    <div class="detailed-infos-top two-cols">
      <div class="col1">
      <div class="vignette cote">
          <div class="vignette-title bg-brightyellow tx-upp tx-darkblue tx-bold">Cote globale</div>
          <div class="vignette-content bg-lightblue tx-center"><span class="tx-darkblue tx-bold">${d.cote_2022}</span><span class="tx-darkblue tx-bold semi-opaque">&nbsp;/&nbsp;10</span></div>
        </div>
        <div class="vignette classement">
          <div class="vignette-title bg-brightyellow tx-upp tx-darkblue tx-bold">Classement</div>
          <div class="vignette-content bg-lightblue tx-center"><span class="tx-darkblue tx-bold">${d.rang}</span><span class="tx-darkblue tx-bold semi-opaque">&nbsp;/&nbsp;468</span></div>
        </div>
      </div>
      <div class="col2">
        <span class="tx-darkblue tx-bold tx-upp">ÉCOLE ${francoAnglo} ${financement}</span> ${d.adresse}, ${d.municipalite}</br>
        <span class="tx-darkblue tx-bold">${d.étudiants} ÉLÈVES</span> ${ehdaaTxt}
      </div>
    </div>
    <div class="detailed-infos-bottom two-cols">
      <div class="col1">
        <table>
          <tr>
            <td class="tx-darkblue tx-bold">RÉSULTATS (%)</td>
            <td class="tx-darkblue tx-bold">2022</td>
            <td class="tx-blue tx-bold semi-opaque">TEND.</td>
          </tr>
          <tr>
            <td class="tx-gray">⋅ Langue d'enseignement</td>
            <td class="tx-darkblue tx-bold">${pnum(d.lens_2022)}</td>
            <td class="tx-blue tx-bold semi-opaque">${returnProperIcon(d.lens_trend)}</td>
          </tr>
          <tr>
            <td class="tx-gray">⋅ Langue seconde</td>
            <td class="tx-darkblue tx-bold">${pnum(d.lsec_2022)}</td>
            <td class="tx-blue tx-bold semi-opaque">${returnProperIcon(d.lsec_trend)}</td>
          </tr>
          <tr>
            <td class="tx-gray">⋅ Science et technologie</td>
            <td class="tx-darkblue tx-bold">${pnum(d.scie_2022)}</td>
            <td class="tx-blue tx-bold semi-opaque">${returnProperIcon(d.scie_trend)}</td>
          </tr>
          <tr>
            <td class="tx-gray">⋅ Mathématiques</td>
            <td class="tx-darkblue tx-bold">${pnum(d.math_2022)}</td>
            <td class="tx-blue tx-bold semi-opaque">${returnProperIcon(d.math_trend)}</td>
          </tr>
          <tr>
            <td class="tx-gray">⋅ Taux d’échec</td>
            <td class="tx-darkblue tx-bold">${pnum(d.echec_2022)}</td>
            <td class="tx-blue tx-bold semi-opaque">${returnProperIcon(d.echec_trend)}</td>
          </tr>
        </table>
      </div>
      <div class="col2">
        <table>
          <tr>
            <td class="tx-darkblue tx-bold">AUTRES FACTEURS (%)</td>
            <td class="tx-darkblue tx-bold">2022</td>
            <td class="tx-blue tx-bold semi-opaque">TEND.</td>
          </tr>
          <tr>
            <td class="tx-gray">⋅ Surestimation </td>
            <td class="tx-darkblue tx-bold">${pnum(d.sures_2022)}</td>
            <td class="tx-blue tx-bold semi-opaque">${returnProperIcon(d.sures_trend)}</td>
          </tr>
          <tr>
            <td class="tx-gray">⋅ Écarts sexes: langue </td>
            <td class="tx-darkblue tx-bold">${pnum(d.ecart_sexes_lens_2022)}</td>
            <td class="tx-blue tx-bold semi-opaque">${returnProperIcon(d.ecart_sexes_lens_trend)}</td>
          </tr>
          <tr>
            <td class="tx-gray">⋅ Écarts sexes: math.</td>
            <td class="tx-darkblue tx-bold">${pnum(d.ecart_sexes_math_2022)}</td>
            <td class="tx-blue tx-bold semi-opaque">${returnProperIcon(d.ecart_sexes_math_trend)}</td>
          </tr>
          <tr>
            <td class="tx-gray">⋅ Taux de retard</td>
            <td class="tx-darkblue tx-bold">${pnum(d.prog_2022)}</td>
            <td class="tx-blue tx-bold semi-opaque">${returnProperIcon(d.prog_trend)}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
            </td>`
            })
      } else { /** if already expanded, remove class and remove details container **/
      sel.classed("expanded",false)
        d3.select(selDetailsId).remove()
      }
    }

    if (data.ecoles.length > 0) {
      render_results(data.ecoles)
    } else {
      render_no_results()
    }

    // Comparator/Map related events
    document.addEventListener("map-school-deselected", (e) => {deselect_entry(e.detail.school_code);});
    document.addEventListener("map-school-selected", (e) => {select_entry(e.detail.school_code);});
    document.addEventListener("comparator-school-removed", (e) => {deselect_entry(e.detail.school_code);});
    document.addEventListener("comparator-school-added", (e) => {select_entry(e.detail.school_code);});

  }

  function update_checkboxes() {
    const ds = data.ecoles.filter(d => d.compared);
    if (ds.length === cfg.maxCompare) {
      d3.selectAll('.cb-school:not(:checked)').property("disabled", true)
    } else {
      d3.selectAll('.cb-school').property("disabled", false)
    }
  }

  function highlight_entry(id) {
    const cb = sel.select(`#checkbox-${id}`);

    sel
        .selectAll(".row")
        .classed("highlight", false)

    sel
        .select(`#checkbox-${id}`)
        .classed("highlight", true)
        .node()
        .scrollIntoView({behavior: "smooth"});
  }

  function unhighlight_entry(id) {
    sel
        .select(`div#school-${id}`)
        .classed("highlight", false);
  }

  function deselect_entry(id) {
    d3.select(`#checkbox-${id}`).property("checked", false);
    document.querySelector(`#checkbox-${id}`).closest('tr').classList.remove('added-to-comparator')
    const d = data.ecoles.find(d => d.school_code == id);
    d.compared = false;
    update_checkboxes();
  }

  function select_entry(id) {
    d3.select(`#checkbox-${id}`).property("checked", true);
    document.querySelector(`#checkbox-${id}`).closest('tr').classList.add('added-to-comparator')
    const d = data.ecoles.find(d => d.school_code == id);
    d.compared = true;
    update_checkboxes();
  }

  document.addEventListener('click', function (e) {
    var down_class = ' dir-d '
    var up_class = ' dir-u '
    var regex_dir = / dir-(u|d) /
    var regex_table = /\bsortable\b/
    var element = e.target

    function reClassify(element, dir) {
      element.className = element.className.replace(regex_dir, '') + dir
    }

    function getValue(element) {
      // If you aren't using data-sort and want to make it just the tiniest bit smaller/faster
      // comment this line and uncomment the next one
      return element.getAttribute('data-sort') || element.innerText
      // return element.innerText
    }

    if (element.nodeName === 'TH' && !element.classList.contains("disable-sort")) {
      try {
        /**Spécifique pour ce tableau**/
            // destroy any open details
        var tablerows = document.getElementById("rows").getElementsByTagName("tr");
        for (i = 0; i < tablerows.length; i++) {
          tablerows[i].classList.remove('expanded');
          if (tablerows[i].classList.contains('details')) {
            tablerows[i].remove();
          }
        }
        /**END - Spécifique pour ce tableau**/

        var tr = element.parentNode
        // var table = element.offsetParent; // Fails with positioned table elements
        // this is the only way to make really, really sure. A few more bytes though... ðŸ˜¡
        var table = tr.parentNode.parentNode
        if (regex_table.test(table.className)) {
          var column_index
          var nodes = tr.cells
          // reset thead cells and get column index
          for (var i = 0; i < nodes.length; i++) {
            if (nodes[i] === element) {
              column_index = i
            } else {
              reClassify(nodes[i], '')
            }
          }

          var dir = down_class

          // check if we're sorting up or down, and update the css accordingly
          if (element.className.indexOf(down_class) !== -1) {
            dir = up_class
          }

          reClassify(element, dir)

          // extract all table rows, so the sorting can start.
          var org_tbody = table.tBodies[0]

          // get the array rows in an array, so we can sort them...
          var rows = [].slice.call(org_tbody.rows, 0)

          var reverse = dir === up_class

          // sort them using custom built in array sort.
          rows.sort(function (a, b) {
            var x = getValue((reverse ? a : b).cells[column_index])
            var y = getValue((reverse ? b : a).cells[column_index])
            // var y = (reverse ? b : a).cells[column_index].innerText
            // var x = (reverse ? a : b).cells[column_index].innerText
            return isNaN(x - y) ? x.localeCompare(y) : x - y
          })

          // Make a clone without content
          var clone_tbody = org_tbody.cloneNode()

          // Build a sorted table body and replace the old one.
          while (rows.length) {
            clone_tbody.appendChild(rows.splice(0, 1)[0])
          }

          // And finally insert the end result
          table.replaceChild(clone_tbody, org_tbody)
        }
      } catch (error) {
        console.log(error)
      }
    }
  })
}
